export const formatActivityDuration = (seconds) => {
  if (!seconds || isNaN(seconds)) return "0";

  const totalSeconds = Number(seconds);

  const pluralize = (value, unit, rawValue) => {
    const isPlural = rawValue > 1;
    return `${value} ${unit}${isPlural ? "s" : ""}`;
  };

  // Years → Y.MM / YY.MM
  const years = Math.floor(totalSeconds / (3600 * 24 * 365));
  if (years >= 1) {
    const remainingSeconds = totalSeconds % (3600 * 24 * 365);
    const months = Math.floor(remainingSeconds / (3600 * 24 * 30));
    if (months === 0) return pluralize(years, "year", years);

    const value = `${years >= 10 ? years.toString().padStart(2, "0") : years}.${months
      .toString()
      .padStart(2, "0")}`;
    return pluralize(value, "year", years + months / 12);
  }

  // Months → M.DD / MM.DD
  const months = Math.floor(totalSeconds / (3600 * 24 * 30));
  if (months >= 1) {
    const remainingSeconds = totalSeconds % (3600 * 24 * 30);
    const days = Math.floor(remainingSeconds / (3600 * 24));
    if (days === 0) return pluralize(months, "month", months);

    const value = `${months >= 10 ? months.toString().padStart(2, "0") : months}.${days
      .toString()
      .padStart(2, "0")}`;
    return pluralize(value, "month", months + days / 30);
  }

  // Days → D.HH / DD.HH
  const days = Math.floor(totalSeconds / (3600 * 24));
  if (days >= 1) {
    const remainingSeconds = totalSeconds % (3600 * 24);
    const hours = Math.floor(remainingSeconds / 3600);
    if (hours === 0) return pluralize(days, "day", days);

    const value = `${days >= 10 ? days.toString().padStart(2, "0") : days}.${hours
      .toString()
      .padStart(2, "0")}`;
    return pluralize(value, "day", days + hours / 24);
  }

  // Hours → H.MM
  const hours = Math.floor(totalSeconds / 3600);
  if (hours >= 1) {
    const minutes = Math.floor((totalSeconds % 3600) / 60);
    if (minutes === 0) return pluralize(hours, "hour", hours);

    const value = `${hours}.${minutes.toString().padStart(2, "0")}`;
    return pluralize(value, "hour", hours + minutes / 60);
  }

  // Minutes → M.SS
  const minutes = Math.floor(totalSeconds / 60);
  if (minutes >= 1) {
    const sec = Math.floor(totalSeconds % 60);
    if (sec === 0) return pluralize(minutes, "minute", minutes);

    const value = `${minutes}.${sec.toString().padStart(2, "0")}`;
    return pluralize(value, "minute", minutes + sec / 60);
  }

  // Seconds
  const val = totalSeconds % 1 === 0 ? totalSeconds : totalSeconds.toFixed(2);
  return pluralize(val, "second", totalSeconds);
};